// extracted by mini-css-extract-plugin
export default {"diffStatesWrapper":"PullRequestHeader-module__diffStatesWrapper__O0EiDi8"};